import CmsAPI from "common/apis/CmsAPI";
import { useEffect, useRef, useState } from "react";

export const useSceneJobs = ({ onJobSucceed, onJobProcessing = () => { }, onJobFailed }) => {
    const jobs = useRef([]);
    const tries = useRef(0);
    const [jobsRecentlyPushed, setJobsRecentlyPushed] = useState(true);

    const checkTimeout = useRef(null);

    const pushJobs = (newJobs) => {
        const filteredJobs = newJobs.filter(newJobId => newJobId && !jobs.current.find(id => id === newJobId));
        jobs.current = [...jobs.current, ...filteredJobs];
        setJobsRecentlyPushed(true);
    }

    const checkJob = async (jobId) => {
        try {
            let jobDetails = await CmsAPI.getJobDetails(jobId);
            console.log('jobDetails', jobDetails);
            if (jobDetails.status === 'failed') {
                console.log('jobDetails status failed', jobId);
                onJobFailed !== null && onJobFailed(jobDetails);
                jobs.current = jobs.current.filter(id => id !== jobId);
                return;
            }

            // Retry on 404
            if (jobDetails.response && jobDetails.response.status === 404) {
                console.log(`404, probing again`, jobId);
                return;
            }

            // If job isn't done yet, try to get the job details again in 3 seconds, max 15 times
            if (jobDetails.outputs[0].url == null) {
                console.log(`Not done yet, probing again`, jobId);
                onJobProcessing(jobId, jobDetails);
                return;
            }

            console.log('checkJob', jobDetails);
            if ((jobDetails.outputs[0].label == "enhanced" || jobDetails.outputs[0].label == 'avatar') && jobDetails.status != 'succeeded' && tries.current <= 100) {
                console.log(`Not done yet, probing again enhanced or avatar job`, jobId);
                onJobProcessing(jobId, jobDetails);
                return;
            }

            // Jub succeeded
            if (jobDetails.status == 'succeeded') {
                // Now we can show the actual thumbnail
                console.log('Job succeeded');

                if (onJobSucceed !== null) {
                    onJobSucceed(jobId, jobDetails);
                    jobs.current = jobs.current.filter(id => id !== jobId);
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    const checkJobs = async () => {
        if (!jobs.current.length) {
            return;
        }

        await Promise.all(jobs.current.map(jobId => checkJob(jobId)));

        if (jobs.current.length) {
            tries.current++;
            checkTimeout.current = setTimeout(() => {
                checkTimeout.current = null;
                checkJobs();
            }, 3000 * tries.current);
        } else {
            checkTimeout.current = null;
            tries.current = 0;
        }
    }

    useEffect(() => {
        if (jobsRecentlyPushed) {
            if (!checkTimeout?.current && jobs.current.length) {
                // Start checking jobs
                checkJobs();
            }

            setJobsRecentlyPushed(false);
        }

    }, [jobsRecentlyPushed]);

    useEffect(() => {
        return () => {
            clearTimeout(checkTimeout.current);
            checkTimeout.current = null;
            tries.current = 0;
        }
    }, [])

    return {
        pushJobs,
    }
}
